module.exports = __webpack_public_path__ + "static/SportsConnect-ca5dd297336d157c5538359e547bb993.jpg";